<template>
  <div>
    <v-row align="center">
      <span class="mb-2 mt-2 text-caption" v-if="!conjuge">{{$api.UI.Format.DocumentoFederal(documento)}} - {{nome}}</span>
      <span class="mb-2 mt-2 text-caption" v-else>{{$api.UI.Format.DocumentoFederal(documentoConjuge)}} - {{nomeConjuge}}</span>
      <template v-if="opcional">
        <v-spacer></v-spacer>
        <span class="mb-1 mr-2 text-caption">
          Assina a CCB
        </span>
        <v-checkbox hide-details class="shrink mt-0 mb-2" v-model="mostrarCCB" @change="changeMostrarCCB"></v-checkbox>
      </template>
    </v-row>
    <input-multiselect :readonly="opcional && !active"
                         :disabled="opcional && !active"
                         ref="el"
                         open-on-clear
                         v-model="model"
                         hide-details
                         :options="conjuge? papeisConjuge : papeis"
                         return-object
                         class="mb-1">
      <template v-slot:selection="{ index }">
        <v-chip v-if="index === 0 && !(opcional && !mostrarCCB)" class="mr-2" label outlined>
          {{ model.length + (model.length === 1 ? ' papel selecionado' :  ' papéis selecionados') }}
        </v-chip>
      </template>

      <template v-slot:prepend-inner>
        <v-chip v-if="opcional && !mostrarCCB" label outlined disabled class="mt-n1">
          <v-icon medium left>
            ph-warning-circle
          </v-icon>
          O participante não assina a CCB
        </v-chip>
        <v-chip v-else-if="model.length === 0" label outlined class="mt-n1">
          <v-icon medium left>
            ph-warning-circle
          </v-icon>
          Nenhum papel selecionado
        </v-chip>
      </template>
    </input-multiselect>
    <v-row style="min-height: 20px">
      <v-col cols="10" class="text-caption pa-0">
        <span v-show="mostrarPapeis" v-for="(papel, l) in model" :key="l">
          - {{ papel.text }}<br />
        </span>
      </v-col>
      <v-col cols="2" v-if="model.length > 0" class="text-caption text-right pa-0">
        <a @click="mostrarPapeis = !mostrarPapeis" class="text-caption">{{ !mostrarPapeis ? 'Exibir Papéis' : 'Minimizar' }}</a>
      </v-col>
    </v-row>
  </div>
</template>
<script>

export default {
  props: {
    showPapeis: { type: Boolean, default: false },
    value: null,
    tipo: null,
    conjuge: { type: Boolean, default: false },
    opcional: { type: Boolean, default: false },
    active: null,
    nome: null,
    documento: null,
    nomeConjuge: null,
    documentoConjuge: null,
    proposta: null,
    listDocFederalGarantia: []
  },
  data () {
    return {
      search: '',
      modelBase: [],
      mostrarPapeis: false
    }
  },
  watch: {
    showPapeis (val) {
      this.mostrarPapeis = val
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
        const hasChanges = JSON.stringify(value) !== JSON.stringify(this.modelBase)
        this.$emit('hasChanges', hasChanges)
      }
    },
    mostrarCCB: {
      get () {
        return this.active
      },
      set (value) {
        this.$emit('activated', value)
      }
    },
    papeis () {
      var list = this.$api.Estruturadas.listPapeis(this, this.tipo, this.model, this.proposta, this.documento, this.listDocFederalGarantia)
      return this.alteraNome(this.tipo, list)
    },
    papeisConjuge () {
      var list = this.$api.Estruturadas.listPapeis(this, this.$api.Estruturadas.TipoAssinanteEnum.Conjuge, this.model, this.proposta, this.documentoConjuge, this.listDocFederalGarantia)
      return this.alteraNome(this.$api.Estruturadas.TipoAssinanteEnum.Conjuge, list)
    }
  },
  methods: {
    changeMostrarCCB (value) {
      if (!value) {
        this.$set(this, 'model', [])
      }
    },
    excluir (assinante, index) {
      assinante.Items.splice(index, 1)
    },
    alteraNome (tipo, list) {
      list.forEach(l => {
        l.text = l.text.replace('@CONJUGENOME', this.nome)
        l.value = typeof l.value === 'string' ? l.value.replace('@CONJUGENOME', this.nome) : l.value
        l.text = l.text.replace('@CONJUGEDOCUMENTO', this.documento)
        l.value = typeof l.value === 'string' ? l.value.replace('@CONJUGEDOCUMENTO', this.documento) : l.value
        l.text = l.text.replace('@EMITENTENOME', this.proposta.Cliente.Nome)
        l.value = typeof l.value === 'string' ? l.value.replace('@EMITENTENOME', this.proposta.Cliente.Nome) : l.value
        l.text = l.text.replace('@EMITENTEDOCUMENTO', this.proposta.Cliente.DocumentoFederal)
        l.value = typeof l.value === 'string' ? l.value.replace('@EMITENTEDOCUMENTO', this.proposta.Cliente.DocumentoFederal) : l.value
      })

      return list
    },
  },
  mounted () {
    this.modelBase = this.value
  }
}
</script>
